module.exports = __webpack_public_path__ + "img/scille.56a3c470.jpg";